import { render, staticRenderFns } from "./ContentRibbon.vue?vue&type=template&id=f73999c0&scoped=true&"
import script from "./ContentRibbon.vue?vue&type=script&lang=js&"
export * from "./ContentRibbon.vue?vue&type=script&lang=js&"
import style0 from "./ContentRibbon.vue?vue&type=style&index=0&id=f73999c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73999c0",
  null
  
)

export default component.exports